export default "__VITE_ASSET__cfxcxo9S__"